import React from 'react';
import Loadable from 'react-loadable';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;
let ListPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../queer50_2021').default;
  // eslint-disable-next-line global-require
  ListPageComponent = require('../queer50_list_page').default;
}

export function queer50List(store) {
  const routeConfig = {
    path: '/queer-50/:slug(list)/:sub(rank)?/:rank?',
    component() {
      if (ListPageComponent) {
        return <ListPageComponent />;
      }
      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: ListPageComponent ? ListPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('../queer50_list_page').then(resp => {
        ListPageComponent = resp.default;
        return ListPageComponent;
      });
    },
    chunk: 'queer50'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="queer50-list-page">
          <article className="queer50-list-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function queer50Annual(store) {
  const routeConfig = {
    path: '/queer-50/:year(2021|list)',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store) : false,
    preloadChunk() {
      return import('../queer50_2021').then(resp => {
        Component = resp.default;
        // routeConfig.loadData = () => {};
        return Component;
      });
    },
    chunk: 'queer50'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="queer50-page">
          <article className="queer50-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
